import React from 'react'
import { Navigate } from 'react-router'

import { ROUTES } from 'consts'

const Dashboard = () => <Navigate to={ROUTES.CATEGORIES} replace />

export default Dashboard
